export var ViewMode = {
    Default: 'default',
    Wide: 'wide',
    Flyout: 'flyout',
};
export var FlyoutTileID = 'flyout';
export var AppBarDefaultValue = 48;
export var TileDimensionDefaultValue = 40;
export var SelectionBarDefaultValue = 32;
export var AppBarWideValue = 68;
export var TileHeightWideValue = 56;
export var SelectionBarWideValue = 48;
export var AppBarBottomMargin = TileDimensionDefaultValue;
export var AppBarDividerMaxHeightValue = 4;
export var AppFlyoutMaxHeight = 484 + 'px';
export var AppFlyoutMinHeight = 376 + 'px';
export var AppFlyoutSmallMinHeight = 282 + 'px';
export var AppFlyoutSmallMaxHeight = 376 + 'px';
export var AppFlyoutNoFooterHeight = 441 + 'px';
export var AppFlyoutNoFooterMinHeight = 282 + 'px';
export var AppFlyoutWidth = 340 + 'px';
export var AppFlyoutFlexContainerHeight = '100%';
export var AppFlyoutFlexContainerWidth = '100%';
export var FlyoutIconSize = 28 + 'px';
export var FlyoutTileHeight = '104px';
export var FlyoutTileWidth = '100px';
export var FlyoutTileIconSize = '48px';
export var FlyoutFooterHeight = '64px';
export var FlyoutFooterMinHeight = '40px';
export var FlyoutTileContainerHeight = '401px';
export var FlyoutTileContainerMaxHeightWithSearch = '370px';
export var FlyoutTileContainerWidth = '95%';
export var FlyoutTileContainerTopMargin = '16px';
export var FlyoutTileContainerLeftPadding = '1px';
export var FlyoutTilesGap = '2px';
export var FlyoutFlexContainerWidth = '90%';
export var FlyoutDividerHeight = '1px';
export var FlyoutFooterDividerWidth = '90%';
export var FlyoutResultsDividerWidth = '284px';
export var FlyoutScrollBarHeight = '40px';
export var FlyoutScrollBarWidth = '6px';
export var FlyoutScrollBarThumbBorderRadius = '4px';
export var AppBarDefault = AppBarDefaultValue + 'px';
export var AppBarWide = AppBarWideValue + 'px';
export var SelectionBarDefault = SelectionBarDefaultValue + 'px';
export var SelectionBarWide = SelectionBarWideValue + 'px';
export var TileDimensionDefault = TileDimensionDefaultValue + 'px';
export var TileHeightWide = TileHeightWideValue + 'px';
export var BadgeSize = '16px';
export var TileMarginDefaultValue = 3;
export var TileMarginDefault = TileMarginDefaultValue + 'px';
export var SelectionBarMarginTopDefault = (TileDimensionDefaultValue - SelectionBarDefaultValue) / 2 +
    TileMarginDefaultValue;
export var SelectionBarMarginTopWide = (TileHeightWideValue - SelectionBarWideValue) / 2;
export var MinTiles = 1; // Minimum number of non-hoisted, non-flyout button tiles to enforce
export var AppBarMinHeight = MinTiles * (TileDimensionDefaultValue + 2 * TileMarginDefaultValue) + 'px';
export var AppBarMinHeightWide = MinTiles * TileHeightWideValue + 'px';
export var TileIconSizeDefault = '20px';
export var TileOutlineIconSizeWide = '20px';
export var TileIconSizeWide = '24px';
export var AppBarDividerMaxHeight = AppBarDividerMaxHeightValue + 'px';
/**
 * Media Queries
 **/
// Max Width 320px
export var AppFlyoutHeightMaxWidth320 = '250px';
export var AppFlyoutWidthMaxWidth320 = '250px';
export var MessageExtensionsAppFlyoutHeightMaxWidth320 = '250px';
export var MessageExtensionsAppFlyoutWidthMaxWidth320 = '250px';
export var FlyoutTileHeightMaxWidth480 = '92px';
export var FlyoutTileWidthMaxWidth480 = '75px';
export var OutlineIconFilterID = 'appbar-outline-icon-filter';
export var FlyoutSearchBoxID = 'flyout-search-box';
// DND Constants
export var DND_MINIMUM_ACTIVATION_DISTANCE_Y_AXIS_PX = 2;
export var DND_TOUCH_SENSOR_TOLERANCE_PX = 10;
export var DND_TOUCH_SENSOR_DELAY_MS = 250;
//# sourceMappingURL=Constants.js.map